export function formatDecimal(value) {
    // Check if the input is a number.  Handle non-number inputs.
    if (typeof value !== 'number') {
        return 0;
    }

    // Use Number.isInteger to efficiently check for integer.
    if (Number.isInteger(value)) {
        return value.toString(); // Return as string, consistent with other return.
    } else {
        // toFixed(4)  formats to 4 decimal places.
        return value.toFixed(4);
    }
}